import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { ArrayResponse, BaseResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  constructor(private http: HttpClient) { }

  getSources(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/env/sources`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getCountries(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/env/countries`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getRoles(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/env/roles`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getPanOutStates(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/env/panOutStates`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getStatuses(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/env/statuses`)
    .pipe(
      map((data: any) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getKeywordTypes(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/env/keyword-types`)
    .pipe(
      map((data: any) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getIntervalModes(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/env/keyword-interval-modes`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getTxMoStates(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/tx/env/mo-states`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getTxMtStates(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/tx/env/mt-states`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getTxMoEventTypes(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/tx/env/mo-event-types`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getTxMtEventTypes(): Observable<BaseResponse> {
    return this.http.get(`${environment.apiUrl}/tx/env/mt-event-types`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getReminderPeriods(): any[] {
    let m = [];
    m.push({'code':1, 'name':'Weekly'});
    m.push({'code':2, 'name':'Montly'});
    return m;
  }

  getKeywordCategories(): any[]{
    let m = [];
    m.push({'code': 1, 'name': 'CBS'});
    m.push({'code': 2, 'name': 'TBS'});
    return m;
  }

}
